// extracted by mini-css-extract-plugin
module.exports = {"panel":"docs_panel__1ISll","link":"docs_link__28YtJ","icon":"docs_icon__3426V"};